import './Sticker.css'

import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getBrandLogo } from '../../../helpers/getBrandLogo'
import icon from '../../../imgs/logo.png'
import Barcode from './Barcode'

export default function Sticker(props) {
  // console.log("🚀 - Sticker - props", props);
  const [isBrandLoaded, setisBrandLoaded] = useState(false)
  let stateData = {}
  const params = useParams()

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
  }, [])

  if (props.data) {
    stateData = {
      name: props.data.name,
      unit: props.data.unit,
      trackingNumberToIsrael: props.data.trackingNumberToIsrael,
      brand: props.data.brand,
      address: props.data.address,
    }
  } else {
    // console.log("🚀 - Sticker - params", params);
    stateData = {
      name: params.name,
      unit: params.unit,
      trackingNumberToIsrael: params.pId,
      brand: params.brand,
      address: params.address,
    }
  }
  // console.log("🚀 - Sticker - stateData", stateData);

  // const data = {
  //     name: "Israel Israeli",
  //     unit: "501122334",
  //     pId: "b8ad6d60-94f3-11ec-8cd5-ee8d634328da",
  //     brand: "Zara"
  // }
  const config = {
    marginTop: '20px',
    marginBottom: '20px',
    fontOptions: 'italic',
    width: 6,
    format: 'CODE128',
  }

  useEffect(() => {
    if (isBrandLoaded) {
      window.print()
      if (props.handleAfterPrint) props.handleAfterPrint()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBrandLoaded])

  return (
    <div className='sticker-cmp'>
      <div>{new Date().toLocaleDateString('en-IL')}</div>
      <div className='sticker-cmp-title'>{stateData.name}</div>
      <div style={{ fontSize: '100px' }}>{stateData.unit}</div>
      <br />
      <div>{stateData.address}</div>
      <Barcode value={stateData.trackingNumberToIsrael} {...config}></Barcode>
      <div>{stateData.trackingNumberToIsrael}</div>
      <img src={getBrandLogo(stateData.brand)} className='sticker-cmp-brand' onLoad={() => setisBrandLoaded(true)} />
      <img src={icon} className='sticker-cmp-logo' />
    </div>
  )
}
